const fileUpload = $parse => {
  return {
    restrict: 'A',
    link: function(scope, element, attributes) {
      var model = $parse(attributes.fileUpload)
      var modelSetter = model.assign

      element.bind('change', () => {
        scope.$apply(() => {
          modelSetter(scope, element[0].files[0])
        })
      })
    },
  }
}

angular.module('app.directives').directive('fileUpload', ['$parse', fileUpload])



// WEBPACK FOOTER //
// ./scripts/shared/directives/file-upload.js